import React, { useState } from "react";
import { useSelector } from "react-redux";
import CommonPopup from "./CommonPopup";
import NewsLinePopup from "./NewsLinePopup";

const NewsLine = () => {
  let DD = useSelector((e: any) => e.domainDetails);
  const [newsPopup, setNewsPopup] = useState(false);

  const message = String(DD?.userMessage || "").trim();

  if (!message || DD?.userMessageLock === true) return null;

  return (
    <>
      <div
        className="marquee-box "
        style={{ display: "flex", marginBottom: "2px" }}
      >
        <h4>News</h4>
        <div className="marquee">
          <div className="js-marquee-wrapper">
            <div className="js-marquee">
              <a onClick={() => setNewsPopup(true)}>{message}</a>
            </div>
          </div>
        </div>
      </div>

      {newsPopup && (
        <CommonPopup
          title={`Announcement`}
          OpenModal={newsPopup}
          closeModel={() => setNewsPopup(false)}
          customclass="newspopup"
          closebtn={true}
        >
          <NewsLinePopup eventData={message} />
        </CommonPopup>
      )}
    </>
  );
};

export default NewsLine;
